var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencilDarkGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77812 13.1246L2.77813 13.1245L10.7612 5.14142L12.8586 7.23875L4.87546 15.2219L4.87545 15.2219C4.44152 15.6559 3.85295 15.8999 3.23919 15.9C3.23918 15.9 3.23918 15.9 3.23917 15.9H2.1V14.7608C2.1 14.7608 2.1 14.7608 2.1 14.7608C2.10014 14.1471 2.34406 13.5585 2.77812 13.1246Z",
    fill: "#666666",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4478 2.55216L15.4478 2.55224C15.5912 2.69543 15.7049 2.86547 15.7825 3.05264C15.8601 3.23981 15.9 3.44044 15.9 3.64305C15.9 3.84567 15.8601 4.04629 15.7825 4.23346C15.7049 4.42063 15.5912 4.59067 15.4478 4.73387L15.4478 4.73389L13.3225 6.85859L11.1414 4.67749L13.2661 2.55219L13.2661 2.55216C13.4093 2.40882 13.5794 2.2951 13.7665 2.21752C13.9537 2.13993 14.1543 2.1 14.3569 2.1C14.5596 2.1 14.7602 2.13993 14.9474 2.21752C15.1345 2.2951 15.3046 2.40882 15.4478 2.55216Z",
    fill: "#666666",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilDarkGray);
export default __webpack_public_path__ + "static/media/iconPencilDarkGray.e97b5cb8e5bab07f355d56524990a534.svg";
export { ForwardRef as ReactComponent };